import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent {
  uploadMode: 'separate' | 'merge' = 'separate';

  constructor(private dialogRef: MatDialogRef<FileUploadDialogComponent>) {}

  choose(mode: 'separate' | 'merge') {
    this.uploadMode = mode;
     this.dialogRef.close(this.uploadMode);
  }

  cancel() {
    this.dialogRef.close();
  }

  // continue() {
  //   this.dialogRef.close(this.uploadMode);
  // }
}
